import {
  BarChart3,
  Bus,
  ClipboardCheck,
  GitBranch,
  LayoutDashboard,
  WalletCards,
  ListChecks,
  Vote,
  ScrollText,
  Settings,
  UserCog,
  ContactRound,
  UserRoundSearch,
  Users,
} from 'lucide-react';
import {
  ACTIONS,
  RESOURCES,
  ROLES,
  createPermission,
} from './accessControl';

const {
  ADMINISTRADOR,
  ADMINISTRADOR_GENERAL,
  COORDINADOR,
  PUNTERO,
  VOTANTE,
} = ROLES;

export const navigationItems = Object.freeze([
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
    resource: RESOURCES.DASHBOARD,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR, PUNTERO],
    permission: createPermission(RESOURCES.DASHBOARD, ACTIONS.VIEW),
  },
  {
    name: 'Estructura electoral',
    path: '/estructura-electoral',
    icon: GitBranch,
    resource: RESOURCES.STRUCTURE,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR],
    permission: createPermission(RESOURCES.STRUCTURE, ACTIONS.VIEW),
  },
  {
    name: 'Votantes',
    path: '/votantes',
    icon: Users,
    resource: RESOURCES.VOTERS,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR, PUNTERO],
    permission: createPermission(RESOURCES.VOTERS, ACTIONS.VIEW),
  },
  {
    name: 'Control de planillas',
    path: '/control-planillas',
    icon: ClipboardCheck,
    resource: RESOURCES.CALL_SHEETS,
    roles: [ADMINISTRADOR_GENERAL],
    permission: createPermission(RESOURCES.CALL_SHEETS, ACTIONS.VIEW),
  },
  {
    name: 'Duplicados',
    path: '/duplicados',
    icon: UserRoundSearch,
    resource: RESOURCES.DUPLICATES,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL],
    permission: createPermission(RESOURCES.DUPLICATES, ACTIONS.VIEW),
  },
  {
    name: 'Móviles',
    path: '/moviles',
    icon: Bus,
    resource: RESOURCES.VEHICLES,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR],
    permission: createPermission(RESOURCES.VEHICLES, ACTIONS.VIEW),
  },
  {
    name: 'Conductores',
    path: '/conductores',
    icon: ContactRound,
    resource: RESOURCES.DRIVERS,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR],
    permission: createPermission(RESOURCES.DRIVERS, ACTIONS.VIEW),
  },
  {
    name: 'Día D',
    path: '/dia-d',
    icon: Vote,
    resource: RESOURCES.ELECTION_DAY,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR, PUNTERO, VOTANTE],
    permission: createPermission(RESOURCES.ELECTION_DAY, ACTIONS.VIEW),
  },
  {
    name: 'Revisión de flota',
    path: '/revision-flota',
    icon: ListChecks,
    resource: RESOURCES.VEHICLES,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL],
    permission: createPermission(RESOURCES.VEHICLES, ACTIONS.VIEW),
  },
  {
    name: 'Financiero',
    path: '/financiero',
    icon: WalletCards,
    resource: RESOURCES.FINANCE,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL],
    permission: createPermission(RESOURCES.FINANCE, ACTIONS.VIEW),
  },
  {
    name: 'Reportes',
    path: '/reportes',
    icon: BarChart3,
    resource: RESOURCES.REPORTS,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR],
    permission: createPermission(RESOURCES.REPORTS, ACTIONS.VIEW),
  },
  {
    name: 'Usuarios',
    path: '/usuarios',
    icon: UserCog,
    resource: RESOURCES.USERS,
    roles: [ADMINISTRADOR, ADMINISTRADOR_GENERAL, COORDINADOR],
    permission: createPermission(RESOURCES.USERS, ACTIONS.VIEW),
  },
  {
    name: 'Auditoría',
    path: '/auditoria',
    icon: ScrollText,
    resource: RESOURCES.AUDIT,
    roles: [ADMINISTRADOR],
    permission: createPermission(RESOURCES.AUDIT, ACTIONS.VIEW),
  },
  {
    name: 'Configuración',
    path: '/configuracion',
    icon: Settings,
    resource: RESOURCES.SETTINGS,
    roles: [ADMINISTRADOR],
    permission: createPermission(RESOURCES.SETTINGS, ACTIONS.VIEW),
  },
]);

export const findNavigationItem = (pathname) =>
  navigationItems.find((item) =>
    pathname === item.path ||
    (item.path === '/votantes' && pathname.startsWith('/votantes/')) ||
    (item.path === '/control-planillas' && pathname.startsWith('/control-planillas/'))
    || (item.path === '/moviles' && pathname.startsWith('/moviles/'))
  );
